import { render, staticRenderFns } from "./AdWelfareDrawer.vue?vue&type=template&id=57130ee1&scoped=true"
import script from "./AdWelfareDrawer.vue?vue&type=script&lang=js"
export * from "./AdWelfareDrawer.vue?vue&type=script&lang=js"
import style0 from "./AdWelfareDrawer.vue?vue&type=style&index=0&id=57130ee1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57130ee1",
  null
  
)

export default component.exports